import { 
  Monitor, 
  Package, 
  Users, 
  HelpCircle, 
  Shield,
  Globe,
  Tag,
  UserCheck,
  UserCog,
  Layers,
  Settings,
  Ban,
  FolderOpen,
  Palette,
  Smartphone,
} from "lucide-react";

export const navMainData = [
  {
    title: "Users",
    url: "users",
    icon: UserCheck,
  },
  {
    title: "iOS",
    icon: Smartphone,
    items: [
      { title: "App Catalog", url: "apps", icon: Package },
      { title: "Devices", url: "devices", icon: Monitor },
      { title: "Levels", url: "levels", icon: Layers },
      { title: "Network Rules", url: "network-rules", icon: Shield },
    ],
  },
  {
    title: "Browser",
    icon: Globe,
    items: [
      { title: "Browser Settings", url: "browser-settings" },
      { title: "Groups", url: "browser-groups" },
      { title: "Policies", url: "policies" },
      { title: "Website Categories", url: "categories" },
      { title: "Block Page Design", url: "block-page" },
      { title: "Access Requests", url: "requests" },
      { title: "Result", url: "result" },
      { title: "Analytics", url: "browser-analytics" },
    ],
  },
  {
    title: "Settings",
    icon: Settings,
    items: [
      { title: "Admins", url: "admins" },
      { title: "Restrictions", url: "restrictions" },
      { title: "App Categories", url: "app-categories" },
      { title: "Theme Configurator", url: "theme" },
    ],
  },
];
